export default __webpack_public_path__ + "static/media/visa.f84feb48.svg";